import React from 'react'
import styled from '@emotion/styled'

import vw from 'styles/utils';
import media from 'styles/media';

function SocialMedia() {
  return (
    <Root>
      <Line href='#' target='_blank' rel="noopener">
        <img src={require('assets/images/icons/line.png')} alt="line" />
      </Line>
      <Youtube href='#' target='_blank' rel="noopener">
        <img src={require('assets/images/icons/youtube.png')} alt="youtube" />
      </Youtube>
      <Email href='#' target='_blank' rel="noopener">
        <img src={require('assets/images/icons/email.png')} alt="email" />
      </Email>
    </Root>
  )
}

SocialMedia.propTypes = {}

const Root = styled.div`
  display: none;
  position: fixed;
  top: 50%;
  left: 0;
  transform: translate3d(0, -50%, 0);
  z-index: 11;

  @media ${media.tablet} {
    display: flex;
    flex-direction: column;
  }
`;

const Line = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3398DC;

  ${vw('width', 40, 40, 50)}
  ${vw('height', 40, 40, 50)}

  > img {
    ${vw('width', 25)}
    ${vw('height', 24)}
  }
`;

const Youtube = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #4263A3;

  ${vw('width', 40, 40, 50)}
  ${vw('height', 40, 40, 50)}

  > img {
    ${vw('width', 20)}
    ${vw('height', 15)}
  }
`;

const Email = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3398DC;

  ${vw('width', 40, 40, 50)}
  ${vw('height', 40, 40, 50)}

  > img {
    ${vw('width', 20)}
    ${vw('height', 16)}
  }
`;

export default SocialMedia
